import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';

type UseAddSymbolToWatchlistConfigs = {
  onReject?: UseMutationConfig<any>['onReject'];
  onSettled?: UseMutationConfig<any>['onSettled'];
  onSuccess?: UseMutationConfig<any>['onSuccess'];
};

export default function useAddSymbolToWatchlist({
  onSettled,
  onReject,
  onSuccess,
}: UseAddSymbolToWatchlistConfigs = {}) {
  const { execute: addToWatchlist } = useMutation(API.addSymbolToWatchlist, {
    onSettled,
    onReject,
    onSuccess,
  });

  return { addToWatchlist };
}
